export default __webpack_public_path__ + "static/media/SiteLeaderRole_InformationArchitecture_Thumbnail.e80d92f3.png";